<script>
import SelectField from '@maison/components/form/fields/SelectField.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import fieldMixin from '@maison/mixins/fieldMixin';
import { useField } from '@phoenix/composables/field';

export default {
  components: {
    SelectField,
    TextField,
  },

  mixins: [fieldMixin],

  props: {
    emptyChoice: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    hasOptions() {
      return this.field.options && this.field.options.length > 0;
    },
  },
};
</script>

<template>
  <select-field v-if="hasOptions" v-model="value" :empty-choice="emptyChoice" :should-validate="false" />
  <text-field v-else v-model="value" :should-validate="false" />
</template>
